Vue.component('ack-comparison-media-grid', {
    delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
    template: '#ack-comparison-media-grid',
    mounted() {
  
      
    },
    props:{
      title: {
        type: String,
        default: ''
      },
      mediaCardsComparison:{
        type: Array,
        required: true
      },
      isMobile: {
        type: Boolean
      }
    },
    computed: {

    },
    data() {
      return {
      }
    },
    methods: {

    },
    beforeDestroy() {

    },
    watch: {
      prop1: {
        handler() {

        },
        deep: false
      }
    }
  })